import { memo } from 'react';
import OutlineText from './OutlineText';

const GameModeSelection = function GameModeSelection({ styles, show, players, onStartTeams, onStartSolos, disabled }) {
    //console.log("Rendering GameModeSelection", show, players);
    return (
        <div className={`${styles.gameSelectionSection} ${show && styles.show}`} style={disabled ? { pointerEvents: 'none', opacity: 0.5 } : undefined}>
            <div className={`${styles.titles}`}>
                <OutlineText styles={styles} text="CHOOSE A" className={styles.subTitle} />
                <OutlineText styles={styles} text={<>GAME<br />MODE</>} className={styles.title} />
            </div>
            <div className={`${styles.buttons}`}>
                <button className={`${styles.mainButton}`} onClick={onStartTeams} disabled={disabled || players.length < 2} tabIndex='-1'>
                    <OutlineText styles={styles} text="Play in Teams" />
                </button>
                <button className={`${styles.mainButton} ${styles.alt}`} onClick={onStartSolos} disabled={disabled} tabIndex='-1'>
                    <OutlineText styles={styles} text="Play Individually" />
                </button>
            </div>
        </div>
    )
};

export default GameModeSelection;